import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  name: () => faker.lorem.word(),
  building: 'Building 1',
  floorNumber: 2,
  floorPlanUrl: 'https://picsum.photos/200/300',
});
